import { Component } from '@angular/core';

@Component({
  selector: 'loading-card',
  standalone: true,
  imports: [],
  templateUrl: './loading-card.component.html',
  styleUrl: './loading-card.component.css',
})
export class LoadingCardComponent {}
